export const hiddenSegments = ['/pagamento'];

export const shouldHideNav = (pathname?: string | null): boolean => {
  return hiddenSegments.some((segment) => pathname?.includes(segment));
};
